import type { NavLink } from '@/types'

export const NAV_MAIN: NavLink[] = [
    { label: 'Work', href: '/work' },
    { label: 'Services', href: '/services' },
    { label: 'About', href: '/about' },
    { label: 'Insights', href: '/insights' }
]

export const NAV_CONTACT: NavLink = { label: 'Contact', href: '/contact' }

export const FOOTER_NAV: NavLink[] = [...NAV_MAIN, NAV_CONTACT]

/* Matches the service slugs in the CMS "services" collection. */
export const FOOTER_SERVICES: NavLink[] = [
    { label: 'Marketing Strategy', href: '/services/marketing-strategy' },
    { label: 'Brand Identity', href: '/services/brand-identity' },
    { label: 'Digital Advertising', href: '/services/digital-advertising' },
    { label: 'Performance Marketing', href: '/services/performance-marketing' },
    { label: 'Creative Campaigns', href: '/services/creative-campaigns' },
    { label: 'Marketing Analytics', href: '/services/marketing-analytics' }
]

export const LEGAL_NAV: NavLink[] = [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms and Conditions', href: '/terms' }
]
